import qs from 'qs'

const data = function (aa) {
  return qs.stringify(aa)
  // return JSON.stringify(aa)
}

export default data



// WEBPACK FOOTER //
// ./src/utils/post.js